import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ProjectService } from "../shared/project/project.service";
import { ImportStep } from "./import-step";
import { ImportStepCompletionResult } from "./import-step-completion-result";

export enum ImportStepState {
    NotAvailableForProject = 0,
    NotAvailableYet = 1,
    Available = 5,
    Completed = 10,
}

@Component({
    selector: 'fake selector', // won't be used, cause it's an abstract class
    template: 'fake template'
  })
export abstract class BaseImportStepComponent {
    public abstract readonly step: ImportStep;
    ImportStepState: typeof ImportStepState = ImportStepState;
    public projectId: string;
    protected dataLoading: boolean;

    @Input()
    public stepState: ImportStepState = ImportStepState.NotAvailableYet;

    @Output() stepCompleted = new EventEmitter<ImportStepCompletionResult>();
    @Output() activated = new EventEmitter<BaseImportStepComponent>();

    protected abstract loadDataInternal(): Promise<void>;

    private _isActive: boolean = false;

    public async loadData(): Promise<void> {
        this.dataLoading = true;
        try {
        await this.loadDataInternal();
        } finally {
            this.dataLoading = false;
        }
    }

    public isActive(): boolean {
        return this._isActive;
    }

    public setActive(val: boolean) {
        if (val && this.stepState <= ImportStepState.NotAvailableYet) {
            console.log('Trying to setActive, but stepState is ', ImportStepState[this.stepState]);
            return;
        }
        this._isActive = val;
    }

    constructor(protected projectService: ProjectService) {}

    ngOnInit(): void {
        this.projectId = this.projectService.getProjectId();
    }

    public editClick() {
        this.activated.emit(this);
    }

    protected finishStepSuccessfully(changesApplied: boolean, payload: any = undefined) {
        this.stepCompleted.emit({
            changesApplied: changesApplied,
            payload: payload,
        });
        this.stepState = ImportStepState.Completed;
    }
}